import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Layout } from "antd";

import userAuthApi from "../apis/UserAuth.api";
import { setMenu } from "../redux/store/auth/authDuck";
import { setLoading } from "../redux/store/common/commonDuck";

import ContentComponent from "./layout/ContentComponent";
import FooterComponent from "./layout/FooterComponent";
import HeaderComponent from "./layout/HeaderComponent";
import SiderComponent from "./layout/SiderComponent";

const { Header, Footer, Sider, Content } = Layout;

const PageLayout = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  const [menuShow, setMenuShow] = useState(true);

  const handleMenu = () => {
    setMenuShow(!menuShow);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");

      const media = function handleChange(e) {
        if (e.matches) {
          setMenuShow(false);
        } else {
          setMenuShow(true);
        }
      };

      matchQueryList.addEventListener("change", media);
    }
    if (user && accessToken && refreshToken) {
      readMenuList();
    }
    return () => {
      setIsLoading(false);
    };
  }, []);

  const readMenuList = async () => {
    setIsLoading(true);
    try {
      const menuParam = {
        user_id: user.id === 724 ? 1 : user.id,
        system_id: 0,
      };
      const menuRes = await userAuthApi.getMenuList(menuParam);
      if (menuRes.code === 200) {
        dispatch(setMenu(menuRes.result));
      } else {
        throw menuRes.msg;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      alert(error);
    }
  };

  return (
    <Layout>
      <Sider width={menuShow ? 200 : 0}>
        {" "}
        <SiderComponent />
        <button
          className="menu-fold-button"
          onClick={() => {
            handleMenu();
          }}
          style={
            menuShow
              ? {}
              : {
                  left: "0px",
                  top: "150px",
                }
          }
        >
          {menuShow ? `접기` : `열기`}
        </button>
      </Sider>
      <Layout>
        <Header className="header">
          <HeaderComponent />
        </Header>

        <Content
          className="site-layout-background"
          style={{
            // padding: 24,
            margin: 0,
            height: "100%",
          }}
        >
          <ContentComponent />
        </Content>

        <Footer>
          <FooterComponent />
        </Footer>
      </Layout>
    </Layout>
  );
};

export default PageLayout;
